import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
//import Fingerprint from "@material-ui/icons/Fingerprint";

import FreeBreakfast from "@material-ui/icons/FreeBreakfast"
import VerifiedUser from "@material-ui/icons/VerifiedUser"
import CenterFocusStrong from "@material-ui/icons/CenterFocusStrong"
import Timelapse from "@material-ui/icons/Timelapse"
import Group from "@material-ui/icons/Group"
import Map from "@material-ui/icons/Map"
import queryBuilder from "@material-ui/icons/QueryBuilder"

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";

class BenefitsSection extends React.Component {
  render() {

    const { classes } = this.props;

    return (
      <div className={classes.section} >
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h3 className={classes.description}>
            Save time, money and build a better product with our upfront, unbiased, accelerated planning process.
            </h3>
            <h4 className={classes.description}>
            You wouldn't build a house without an architect or blueprints, would you?
            </h4>
          </GridItem>
        </GridContainer>
        <br />
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Save Time &amp; Money"
                description="Instead of spending weeks or months nurturing your ideas, our intensive planning session will help mature your ideas and articulate a clear, confident plan in just days."
                icon={queryBuilder}
                iconColor="success"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Leverage our Expertise"
                description="You'll get feedback on your ideas, technology choices, timing estimates and your biggest risks – feedback backed by decades of experience building technology products."
                icon={Map}
                iconColor="success"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Interests Aligned"
                description="Unlike &quot;full service firms&quot; we are not trying to sell you on a long and expensive project. We succeed by helping you build a great product as quickly and inexpensively as possible."
                icon={Group}
                iconColor="success"
                vertical
              />
            </GridItem>
          </GridContainer>
        </div>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <br />
            <h5 className={classes.description}>
            Send us an <a href="mailto:info@spiffyVentures.com" style={{color:'navy'}}>email</a> to learn more.
            </h5>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(productStyle)(BenefitsSection);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/BenefitsSection.jsx